import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      chatRef: [],
      reference: null
    }
  },
  getters: {
    chatRef (state) {
      return state.chatRef
    },
    reference (state) {
      return state.reference
    }
  },
  mutations: {
    init (state, payload) {
      state.chatRef = payload
    },
    add (state, payload) {
      state.chatRef.push(payload)
    },
    update (state, payload) {
      const index = state.chatRef.findIndex(ref => ref.key === payload.key)
      if (index !== -1) {
        Vue.set(state.chatRef, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.chatRef.findIndex(ref => ref.key === payload.key)
      if (index !== -1) {
        state.chatRef.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      commit('init', [])
    },
    subscribe ({ commit }, payload) {
      var boot = true
      var temp = []
      return new Promise((resolve, reject) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('chats_refs')
        var reference = dbRef.onSnapshot(snapshots => {
          if (snapshots.empty) {
            resolve()
          }
          snapshots.docChanges().forEach(change => {
            var payload = change.doc.data()
            payload.key = change.doc.id
            var data = JSON.parse(JSON.stringify(payload))
            if (boot && change.type === 'added') {
              temp.push(data)
            } else if (change.type === 'added') {
              commit('add', data)
            } else if (change.type === 'modified') {
              commit('update', data)
            } else if (change.type === 'removed') {
              commit('remove', data)
            }
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        })
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      return new Promise((resolve, reject) => {
        var reference = store.getters['chatRefStatus/reference']
        if (reference) {
          reference()
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    }
  }
}
